import xmlFormat from 'xml-formatter';

function formatPhoneNumber(phone) {
  const re = /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;
  if (phone) {
    const groups = re.exec(phone);
    return groups
      ? `${groups[1] ? `+${groups[1]}` : ''}(${groups[2]}) ${groups[3]}-${
          groups[4]
        }`
      : false;
  }
}

function sortData(a, b) {
  if (a.lastUpdated > b.lastUpdated) return 1;
  if (a.lastUpdated < b.lastUpdated) return -1;
  return 0;
}

const getInitials = name => {
  if (!name) {
    return '';
  }
  const [first, second] = name.split(' ');
  if (second) {
    return first.charAt(0) + second.charAt(0);
  }
  if (first) {
    return first.substring(0, 2);
  }
};

const formatExample = (exampleBody) => {
  if (typeof exampleBody === 'object' || typeof exampleBody === 'boolean' || typeof exampleBody === 'number' || Array.isArray(exampleBody)) {
    return JSON.stringify(exampleBody, null, 4);
  } else {
    try {
      // xml format will throw if malformed
      return xmlFormat(exampleBody);
    } catch {
      // return the original value if no formatting available
      return exampleBody;
    }
  }
};

export { formatPhoneNumber, sortData, getInitials, formatExample };
